import { get } from 'lodash'

function CountryFromPathname() {
    const pathnames = window.location.pathname.split('/')
    let country = get(pathnames, 1, 'select-country')
    if (/^\/feature/.test(window.location.pathname)) {
        country = get(pathnames, 4, 'select-country')
    } else if (/^\/epic/.test(window.location.pathname)) {
        country = get(pathnames, 6, 'select-country')
    }
    return country
}

function BuildBasename(country) {
    const pathnames = window.location.pathname.split('/')

    if (/^\/feature/.test(window.location.pathname)) {
        pathnames[4] = country
    } else if (/^\/epic/.test(window.location.pathname)) {
        pathnames[6] = country
    } else {
        pathnames[1] = country
    }

    const basename = pathnames.join('/')
    let arrayBasename = basename.split('/')
    if (/^\/feature/.test(window.location.pathname)) {
        arrayBasename = pathnames.slice(0, 5)
    } else if (/^\/epic/.test(window.location.pathname)) {
        arrayBasename = pathnames.slice(0, 7)
    } else {
        arrayBasename = pathnames.slice(0, 2)
    }

    return arrayBasename.join('/')
}

function Segments() {
    return window.location.pathname.split('/')
}

function Segment(segmentIndex) {
    const pathnames = window.location.pathname.split('/')
    if (IsEpic()) {
        return pathnames[segmentIndex + 5]
    } else if (IsFeature()) {
        return pathnames[segmentIndex + 3]
    } else {
        return pathnames[segmentIndex]
    }
}

function IsEpic() {
    return /^\/epic/.test(window.location.pathname)
}

function IsFeature() {
    return /^\/feature/.test(window.location.pathname)
}

function getPostBackUrlDEV(countryLowerCase) {
    const locationURL = window.location
    let pathname = ''

    if (/fg-dev/.test(window.location.href) && !/epic/.test(window.location.href)) {
        const subPath = locationURL.pathname.split('/')
        pathname = `${subPath[1]}/${subPath[2]}/${subPath[3]}`
    } else if (/epic/.test(window.location.href)) {
        const subPath = locationURL.pathname.split('/')
        pathname = `${subPath[1]}/${subPath[2]}/${subPath[3]}/${subPath[4]}/${subPath[5]}`
    }

    const postBackUrlDEV = {
        success: `{{hostname}}/${pathname}/{{country}}/payment-response/success`,
        error: `{{hostname}}/${pathname}/{{country}}/payment-response/failed`
    }

    const hostname = window.location
    const successUrlDEV = postBackUrlDEV.success.replace('{{hostname}}', hostname.origin).replace('{{country}}', countryLowerCase)
    const errorUrlDEV = postBackUrlDEV.error.replace('{{hostname}}', hostname.origin).replace('{{country}}', countryLowerCase)

    return {
        success: successUrlDEV,
        error: errorUrlDEV
    }
}

const getIndexOfCountryInPathname = () => {
    if (/^\/feature/.test(window.location.pathname)) {
        return 4
    } else if (/^\/epic/.test(window.location.pathname)) {
        return 6
    } else {
        return 1
    }
}

const overriderCountryUrl = ({
    countryName,
}) => {

    const pathname = window.location.pathname
    const pathnameArray = pathname.split('/')
    const queryString = window.location.search

    const countryIndex = getIndexOfCountryInPathname()
    pathnameArray[countryIndex] = countryName
    
    window.location.replace(`${pathnameArray.join('/')}${queryString}`)
}

export const PathHelper = {
    CountryFromPathname,
    BuildBasename,
    Segments,
    Segment,
    IsEpic,
    IsFeature,
    getPostBackUrlDEV,
    getIndexOfCountryInPathname,
    overriderCountryUrl
}
